<template>
  <v-footer :padless="true">
    <v-card
      flat
      tile
      width="100%"
      class="text-center"
    >
      <v-card-text>
        Need Help ? Feedback ? <a href="https://indicproject.org/" target="_blank">Contact Us</a><br/><br/>
        <a href="https://varnamproject.com/" target="_blank">Varnam</a> is a Free Software under&nbsp;<a href="https://indicproject.org/" target="_blank">Indic Project</a>. Copyright 2020, <a href="https://github.com/varnamproject/editor/graphs/contributors" target="_blank">Varnam Contributors</a>.
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>
